module.exports = __webpack_public_path__ + "static/media/005-Wechseln_ID_22.aa3a1b63.mp3";